var UserAgent = require('useragent');

export default class CaazamDevice {

    static hasMedia() {
        return !!(
            (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        );
    }

    static isApple() {
        const agent = UserAgent.lookup(navigator.userAgent);
        return (agent.os.family === 'Mac OS X' || agent.os.family === 'iOS');
    }

    static isAndroid() {
        const agent = UserAgent.lookup(navigator.userAgent);
        return (agent.os.family === 'Android');
    }

    canShowFileInputCamera() {
        /*

        Safari 10.0 on iOS devices does allow to open direct to camera (w/o image select from library)
        but its easy to fool the client (change UA string) which will alllow uploading images from desktop
        pretending to be iOS Mobile Safari

        if (this.agent.family === 'Safari' || this.agent.family === 'Mobile Safari') {
            return parseInt(this.agent.major) >= 10;
        } */
        return false;
    }


}


// WEBPACK FOOTER //
// ./src/CaazamModel/CaazamDevice.js